import * as React from 'react';
import { Input } from 'semantic-ui-react';

import { addModifiers } from '../../../../shared/helpers';
import noop from 'lodash/noop';

import HOCSettingsTooltip from './HOCSettingsTooltip';
import { Controller, useForm } from 'react-hook-form';

import moment from 'moment';
import { FormattedMessageHelper } from '../../../../shared/helpers/internationalization';
import { ControllerRenderProps } from 'react-hook-form/dist/types/controller';

interface SettingsInputProps {
  name: string;
  pathOptions: string[];
  onChangeHandler: (
    target: {
      target: { name: string };
    },
    data: { value: string }
  ) => void;
  selection: boolean;
  currentValue: string;
  options: any;
  hasError: boolean;
}

const SettingsISOPeriodInput = ({ currentValue, name, onChangeHandler, hasError }: SettingsInputProps) => {
  const duration = moment.duration(currentValue);

  const { handleSubmit, control, getValues } = useForm({
    defaultValues: {
      year: duration.years().toString(),
      month: duration.months().toString(),
    },
  });

  const onSubmit = noop;

  const formatInputValue = (value = '') => {
    const match = value.match(/\d+/);
    return match ? match[0] : '';
  };

  const createISODuration = () => {
    const { year, month } = getValues();
    const newDuration = moment.duration({ years: Number(year) || 0, months: Number(month) || 0 });
    const isoDuration = newDuration.toISOString();
    return isoDuration;
  };

  const handleFieldChange = (field: ControllerRenderProps<any, any>) => async (e: React.ChangeEvent<HTMLInputElement>) => {
    await field.onChange({ target: { value: formatInputValue(e.target.value) } });

    onChangeHandler({ target: { name } }, { value: createISODuration() });
  };

  return (
    <form className="code-editor-settings__iso-period" onSubmit={handleSubmit(onSubmit)}>
      <Controller
        name="year"
        control={control}
        render={({ field }) => (
          <Input
            className={addModifiers('code-editor-settings__form-element-input', ['test-period'].concat(hasError ? ['error'] : []))}
            transparent={true}
            error={hasError}
            {...field}
            onChange={handleFieldChange(field)}
            value={field.value}
            type={'string'}
            label={
              <div className="code-editor-settings__form-element-label">
                <div className="code-editor-settings__form-element-label-name">
                  <FormattedMessageHelper tagName="span" id={'editorSettingsForm.testPeriod.year'} />
                </div>
              </div>
            }
            labelPosition={'right'}
          />
        )}
      />

      <Controller
        name="month"
        control={control}
        render={({ field }) => (
          <Input
            className={addModifiers('code-editor-settings__form-element-input', ['test-period'].concat(hasError ? ['error'] : []))}
            transparent={true}
            error={hasError}
            {...field}
            onChange={handleFieldChange(field)}
            value={field.value}
            type={'string'}
            label={
              <div className="code-editor-settings__form-element-label">
                <div className="code-editor-settings__form-element-label-name">
                  <FormattedMessageHelper tagName="span" id={'editorSettingsForm.testPeriod.month'} />
                </div>
              </div>
            }
            labelPosition={'right'}
          />
        )}
      />
    </form>
  );
};

export default HOCSettingsTooltip(SettingsISOPeriodInput);
